import { Grid } from "@mui/material";
import { BtnAdd, BtnBack, BtnDraft, BtnDuplicate, BtnEdit, BtnSave } from "components/Button/ButtonAll";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { TextAreaItem } from "components/Input/TextArea";
import { TextBoxItem } from "components/Input/TextBox";
import React, { useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { DefaultArrayEmpty, Extension, I18n } from "utilities/utilities";
import { useFundActionPlan, useFundActionPlanTable } from "../hooks/useFundActionPlan";
import AccordionFund from "../components/Accordion";
import { SelectItem } from "components/Input/Select/SelectItem";
import HeaderInput from "../components/HeaderInput";
import Wrapper from "../components/Wrapper";
import { CheckBoxItem } from "components/Input/Checkbox/CheckBoxItem";
import InputNumberItem from "components/Input/InputNumber";
import DividerCustom from "../components/DividerFund";
import { AutoCompleteItem } from "components/Input/AutoComplete";
import FundActionPlanFormDuration from "./FundActionPlanFormDuration";
import FundActionPlanFormBoardMeeting from "./FundActionPlanFormBoardMeeting";
import TableStandard from "../components/Table/TableStandard";
import { TreeSelectCustomItem } from "components/Input/Select/TreeSelectCustomItem";
import TableEmployee from "../components/Table/TableEmployee";
import TableActivity from "../components/Table/TableActivity";
import UploadFileItem from "components/Input/UploadFile";
import moment from "moment";
import { useLocation } from "react-router";

export default function FundActionPlanForm() {

    const location = useLocation();
    const searchParams = location.search;
    const sFundWorkID = new URLSearchParams(searchParams).get("sFundWorkID");

    const { onBack } = useFundActionPlanTable();
    const {
        form,
        formGoal,
        formTarget,
        formStrategic,
        formStrategy,
        formProject,
        formActivity,
        formAssign,
        formBoardMeetingTable,
        formBoardMeeting,
        onAddBoardMeeting,
        onDeleteBoardMeeting,
        arrBoardMeeting,
        dataRowGoal,
        dataRowTarget,
        dataRowStrategic,
        dataRowStrategy,
        dataRowProject,
        dataRowAssign,
        dataRowCommittee,
        dataRowActivity,
        loadingTable,
        onGetCommittee,
        onDeleteGoal,
        onDeleteStrategic,
        onDeleteTarget,
        onDeleteStrategy,
        onDeleteProject,
        onDeleteAssign,
        onDeleteCommittee,
        onDeleteActivity,
        onAddGoal,
        handleChangeOrderGoal,
        handleChangeOrderStrategic,
        handleChangeOrderTarget,
        handleSubmitStrategic,
        handleSubmitTarget,
        handleSubmitStrategy,
        handleSubmitProject,
        handleSubmitAssign,
        handleChangeOrderStrategy,
        handleChangeOrderProject,
        handleChangeFiscalYear,
        handleChangeSubActivity,
        handleChangeBoardMeeting,
        handleSubmitCommittee,
        handleSubmitActivity,
        handleChangeActivity,
        handleChangeProject,
        handleSubmitPlan,
        handleEditGoal,
        handleEditStrategic,
        handleEditTarget,
        handleEditStrategy,
        handleEditProject,
        nEditProject,
        nEditStrategy,
        nEditTarget,
        nEditGoal,
        nEditStrategic,
        nProjectCurrent,
        isSubActivity,
        isBoardMeeting,
        arrOptionIndicator,
        arrOptionOrderGoal,
        arrOptionOrderStrategic,
        arrOptionOrderTarget,
        arrOptionOrderStrategy,
        arrOptionOrderProject,
        arrOptionStrategic,
        arrOptionTarget,
        arrOptionStrategy,
        arrOptionProject,
        nYear,
        arrOptionCommittee,
        dataOptionActivity,
        trigger,
        arrActivity,
        formDuration,
        onAddDuration,
        onDeleteDuration,
        arrDuration,
        arrFileMOU,
        setArrFileMOU,
        arrFilePlan,
        setArrFilePlan,
        handleClearAttachFileMOU,
        handleClearAttachFilePlan,
        handleDraft,
        handleEditActivity,
        onGetDataFundPlan,
        nEditActivity,
        nEditActivityProject,
        onDuplicateForm,
        isSubmitted,
        handleEditCommittee,
        nEditCommittee,
        handleEditAssign,
        nEditAssign,
        nTriggerDuration,
        nMaxMonth,
        nMinMonth,
        setNMaxMonthDueDate,
        setNMinMonthDueDate,
        nMinMonthDueDate,
        nMaxMonthDueDate,
        nMaxBudget,
        nMaxWeight,
        nParentID,
        isPermission
    } = useFundActionPlan();

    useEffect(() => {
        onGetCommittee();
    }, []);

    useEffect(() => {
        if (sFundWorkID)
            onGetDataFundPlan(sFundWorkID);
    }, [sFundWorkID]);

    return (
        // <FuncActionPlanContextProvider>
        <FormProvider {...form}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <DatePickerItem
                        name="sFiscalYear"
                        id="sFiscalYear"
                        label={I18n.SetText("FundPlan.FiscalYear")}
                        IsYearPicker
                        IsDisablePortal={true}
                        required
                        onChange={(e) => handleChangeFiscalYear(e, sFundWorkID)}
                        minDate={moment()}
                        disabled={sFundWorkID !== null}
                    />
                </Grid>
                {isPermission &&
                    <Grid item xs={12} md={6} mt={"2px"}>
                        <BtnDuplicate
                            id="copy"
                            onClick={form.handleSubmit(onDuplicateForm, (err) => {
                                document.getElementById(Object.keys(err)[0])?.focus();
                            })}
                        />
                    </Grid>
                }
                <Grid item xs={12}>
                    <TextAreaItem
                        name="sVision"
                        label={I18n.SetText("FundPlan.Vision")}
                        required
                        maxLength={2000}
                        IsShowTextCont
                        disabled={!isPermission}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextAreaItem
                        name="sMission"
                        label={I18n.SetText("FundPlan.Mission")}
                        required
                        maxLength={2000}
                        IsShowTextCont
                        disabled={!isPermission}
                    />
                </Grid>
                <FormProvider {...formGoal}>
                    {isPermission &&
                        <>
                            <Grid item xs={12}>
                                <TextBoxItem
                                    name="sGoalName"
                                    label={I18n.SetText("FundPlan.GoalName")}
                                    required
                                    maxLength={500}
                                    IsShowTextCont
                                    disabled={!isPermission}
                                />
                            </Grid>

                            <Grid item xs={12} display={"flex"} justifyContent={"right"}>
                                {nEditGoal ?
                                    <BtnEdit
                                        id="EditGoal"
                                        txt={I18n.SetText("FundPlan.EditGoal")}
                                        onClick={formGoal.handleSubmit(onAddGoal, (err) => {
                                            document.getElementById(Object.keys(err)[0])?.focus();
                                        })}
                                    />
                                    :
                                    <BtnAdd
                                        id="AddGoal"
                                        txt={I18n.SetText("FundPlan.AddGoal")}
                                        // onClick={() => {
                                        //     // dispatch({
                                        //     //     type: "AddPurpose", payload: {
                                        //     //         sYear: form.getValues("sFiscalYear"),
                                        //     //         sVision: form.getValues("sVision"),
                                        //     //         sMission: form.getValues("sMission"),
                                        //     //         sPurposeName: form.getValues("sGoalName")
                                        //     //     }
                                        //     // })
                                        // }}

                                        onClick={formGoal.handleSubmit(onAddGoal, (err) => {
                                            document.getElementById(Object.keys(err)[0])?.focus();
                                        })}
                                    />
                                }

                            </Grid>
                        </>
                    }
                </FormProvider>
                <Grid item xs={12}>
                    <Grid item xs={12} >
                        <TableStandard
                            sColumnName={I18n.SetText("FundPlan.GoalName")}
                            data={dataRowGoal}
                            handleChangeOrder={handleChangeOrderGoal}
                            arrOptionOrder={arrOptionOrderGoal}
                            onDelete={onDeleteGoal}
                            onEdit={handleEditGoal}
                            nEditID={nEditGoal}
                            isPermission={isPermission}
                        />
                    </Grid>
                </Grid>

                {/* strategic */}
                <Grid item xs={12}>
                    <AccordionFund
                        header={I18n.SetText("FundPlan.StrategicTopic")}
                    >
                        <FormProvider {...formStrategic}>
                            <Grid container spacing={2}>
                                {isPermission &&
                                    <>
                                        <Grid item xs={12}>
                                            <TextBoxItem
                                                name="sStrategicName"
                                                label={I18n.SetText("FundPlan.StrategicName")}
                                                required
                                                maxLength={500}
                                                disabled={!isPermission}
                                            />
                                        </Grid>

                                        <Grid item xs={12} display={"flex"} justifyContent={"right"}>
                                            {nEditStrategic ?
                                                <BtnEdit
                                                    id="EditStrategic"
                                                    txt={I18n.SetText("FundPlan.EditStrategic")}
                                                    onClick={formStrategic.handleSubmit(handleSubmitStrategic, (err) => {
                                                        document.getElementById(Object.keys(err)[0])?.focus();
                                                    })}
                                                />
                                                :
                                                <BtnAdd
                                                    id="AddStrategic"
                                                    txt={I18n.SetText("FundPlan.AddStrategic")}
                                                    onClick={formStrategic.handleSubmit(handleSubmitStrategic, (err) => {
                                                        document.getElementById(Object.keys(err)[0])?.focus();
                                                    })}
                                                />
                                            }
                                        </Grid>
                                    </>
                                }
                                <Grid item xs={12}>
                                    <TableStandard
                                        sColumnName={I18n.SetText("FundPlan.StrategicName")}
                                        data={dataRowStrategic}
                                        handleChangeOrder={handleChangeOrderStrategic}
                                        arrOptionOrder={arrOptionOrderStrategic}
                                        onDelete={onDeleteStrategic}
                                        onEdit={handleEditStrategic}
                                        nEditID={nEditStrategic}
                                        arrCheckParent={dataRowTarget}
                                        arrCheckParentSec={dataRowStrategy}
                                        sFieldCheck={"nStrategicID"}
                                        isPermission={isPermission}
                                    />
                                </Grid>
                            </Grid>
                        </FormProvider>
                    </AccordionFund>
                </Grid>

                {/* target strategic */}
                <Grid item xs={12}>
                    <AccordionFund
                        header={I18n.SetText("FundPlan.TargetStrategicTopic")}
                    >
                        <FormProvider {...formTarget}>
                            <Grid container spacing={2}>
                                {isPermission &&
                                    <>
                                        <Grid item xs={12}>
                                            <SelectItem
                                                name="sTargetStrategic"
                                                label={I18n.SetText("FundPlan.StrategicName")}
                                                placeholder={`${I18n.SetText("FundPlan.Choose")}${I18n.SetText("FundPlan.Strategic")}`}
                                                required
                                                options={arrOptionStrategic}
                                                disabled={!isPermission}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextBoxItem
                                                name="sTargetStrategicName"
                                                label={I18n.SetText("FundPlan.TargetStrategicName")}
                                                required
                                                maxLength={500}
                                                IsShowTextCont
                                                disabled={!isPermission}
                                            />
                                        </Grid>

                                        <Grid item xs={12} display={"flex"} justifyContent={"right"}>
                                            {nEditTarget ?
                                                <BtnEdit
                                                    id="EditTargetStrategic"
                                                    txt={I18n.SetText("FundPlan.EditTargetStrategic")}
                                                    onClick={formTarget.handleSubmit(handleSubmitTarget, (err) => {
                                                        document.getElementById(Object.keys(err)[0])?.focus();
                                                    })}
                                                />
                                                :
                                                <BtnAdd
                                                    id="AddTargetStrategic"
                                                    txt={I18n.SetText("FundPlan.AddTargetStrategic")}
                                                    onClick={formTarget.handleSubmit(handleSubmitTarget, (err) => {
                                                        document.getElementById(Object.keys(err)[0])?.focus();
                                                    })}
                                                />
                                            }
                                        </Grid>
                                    </>
                                }
                                <Grid item xs={12}>
                                    <TableStandard
                                        sColumnName={I18n.SetText("FundPlan.TargetStrategicName")}
                                        data={dataRowTarget}
                                        handleChangeOrder={handleChangeOrderTarget}
                                        arrOptionOrder={arrOptionOrderTarget}
                                        onDelete={onDeleteTarget}
                                        onEdit={handleEditTarget}
                                        nEditID={nEditTarget}
                                        isPermission={isPermission}
                                    />
                                </Grid>
                            </Grid>
                        </FormProvider>
                    </AccordionFund>
                </Grid>

                {/* strategy */}
                <Grid item xs={12}>
                    <AccordionFund
                        header={I18n.SetText("FundPlan.StrategyTopic")}
                    >
                        <FormProvider {...formStrategy}>
                            <Grid container spacing={2}>
                                {isPermission &&
                                    <>
                                        <Grid item xs={12}>
                                            <SelectItem
                                                name="sStrategyStrategic"
                                                label={I18n.SetText("FundPlan.StrategicName")}
                                                placeholder={`${I18n.SetText("FundPlan.Choose")}${I18n.SetText("FundPlan.Strategic")}`}
                                                required
                                                options={arrOptionStrategic}
                                                disabled={!isPermission}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextBoxItem
                                                name="sStrategyName"
                                                label={I18n.SetText("FundPlan.StrategyName")}
                                                required
                                                maxLength={500}
                                                IsShowTextCont
                                                disabled={!isPermission}
                                            />
                                        </Grid>

                                        <Grid item xs={12} display={"flex"} justifyContent={"right"}>
                                            {nEditStrategy ?
                                                <BtnEdit
                                                    id="EditStrategy"
                                                    txt={I18n.SetText("FundPlan.EditStrategy")}
                                                    onClick={formStrategy.handleSubmit(handleSubmitStrategy, (err) => {
                                                        document.getElementById(Object.keys(err)[0])?.focus();
                                                    })}
                                                />
                                                :
                                                <BtnAdd
                                                    id="AddStrategy"
                                                    txt={I18n.SetText("FundPlan.AddStrategy")}
                                                    onClick={formStrategy.handleSubmit(handleSubmitStrategy, (err) => {
                                                        document.getElementById(Object.keys(err)[0])?.focus();
                                                    })}
                                                />
                                            }
                                        </Grid>

                                    </>
                                }
                                <Grid item xs={12}>
                                    <TableStandard
                                        sColumnName={I18n.SetText("FundPlan.StrategyName")}
                                        data={dataRowStrategy}
                                        handleChangeOrder={handleChangeOrderStrategy}
                                        arrOptionOrder={arrOptionOrderStrategy}
                                        onDelete={onDeleteStrategy}
                                        onEdit={handleEditStrategy}
                                        nEditID={nEditStrategy}
                                        arrCheckParent={dataRowProject}
                                        sFieldCheck={"nStrategyID"}
                                        isPermission={isPermission}
                                    />
                                </Grid>
                            </Grid>
                        </FormProvider>
                    </AccordionFund>
                </Grid>

                {/* Project */}
                <Grid item xs={12}>
                    <AccordionFund
                        header={I18n.SetText("FundPlan.ProjectTopic")}
                    >
                        <FormProvider {...formProject}>
                            <Grid container spacing={2}>
                                {isPermission &&
                                    <>
                                        <Grid item xs={12}>
                                            <SelectItem
                                                name="sProjectStrategy"
                                                label={I18n.SetText("FundPlan.StrategyName")}
                                                placeholder={`${I18n.SetText("FundPlan.Choose")}${I18n.SetText("FundPlan.StrategyName")}`}
                                                required
                                                options={arrOptionStrategy}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextBoxItem
                                                name="sProjectName"
                                                label={I18n.SetText("FundPlan.ProjectName")}
                                                required
                                                maxLength={500}
                                                IsShowTextCont
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextBoxItem
                                                name="sTargetUnit"
                                                label={I18n.SetText("FundPlan.TargetUnit")}
                                                maxLength={150}
                                                IsShowTextCont
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TreeSelectCustomItem
                                                name="sIndicatorRef"
                                                label={I18n.SetText("FundPlan.IndicatorRef")}
                                                placeholder={`${I18n.SetText("FundPlan.Choose")}${I18n.SetText("FundPlan.IndicatorRef")}`}
                                                options={arrOptionIndicator}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Wrapper>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <HeaderInput text={I18n.SetText("FundPlan.IndicatorProject")} required />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Wrapper>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12}>
                                                                    <HeaderInput text={I18n.SetText("FundPlan.Output")} required />
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <TextAreaItem
                                                                        name="sOutputQuantitative"
                                                                        label={I18n.SetText("FundPlan.Quantitative")}
                                                                        required
                                                                        maxLength={500}
                                                                        IsShowTextCont
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <TextAreaItem
                                                                        name="sOutputQualitative"
                                                                        label={I18n.SetText("FundPlan.Qualitative")}
                                                                        maxLength={500}
                                                                        IsShowTextCont
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <HeaderInput text={I18n.SetText("FundPlan.Outcome")} />
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <TextAreaItem
                                                                        name="sOutcomeQuantitative"
                                                                        label={I18n.SetText("FundPlan.Quantitative")}
                                                                        maxLength={500}
                                                                        IsShowTextCont
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <TextAreaItem
                                                                        name="sOutcomeQualitative"
                                                                        label={I18n.SetText("FundPlan.Qualitative")}
                                                                        maxLength={500}
                                                                        IsShowTextCont
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <TextAreaItem
                                                                        name="sImpact"
                                                                        label={I18n.SetText("FundPlan.Impact")}
                                                                        maxLength={500}
                                                                        IsShowTextCont
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Wrapper>
                                                    </Grid>
                                                </Grid>
                                            </Wrapper>
                                        </Grid>
                                        <Grid item xs={12} display={"flex"} justifyContent={"right"}>
                                            {nEditProject ?
                                                <BtnEdit
                                                    id="EditProject"
                                                    txt={I18n.SetText("FundPlan.EditProject")}
                                                    onClick={formProject.handleSubmit(handleSubmitProject, (err) => {
                                                        document.getElementById(Object.keys(err)[0])?.focus();
                                                    })}
                                                />
                                                :
                                                <BtnAdd
                                                    id="AddProject"
                                                    txt={I18n.SetText("FundPlan.AddProject")}
                                                    onClick={formProject.handleSubmit(handleSubmitProject, (err) => {
                                                        document.getElementById(Object.keys(err)[0])?.focus();
                                                    })}
                                                />
                                            }
                                        </Grid>
                                    </>
                                }
                                <Grid item xs={12}>
                                    <TableStandard
                                        sColumnName={I18n.SetText("FundPlan.ProjectName")}
                                        data={dataRowProject}
                                        handleChangeOrder={handleChangeOrderProject}
                                        arrOptionOrder={arrOptionOrderProject}
                                        onDelete={onDeleteProject}
                                        onEdit={handleEditProject}
                                        nEditID={nEditProject}
                                        arrCheckParent={
                                            dataRowActivity.flatMap(item =>
                                                item.lstStrategy.flatMap(strategy =>
                                                    strategy.lstProject.filter(f => f.lstActivity.length > 0).map(project => project)
                                                )
                                            )}

                                        sFieldCheck={"nProjectID"}
                                        isPermission={isPermission}
                                    />
                                </Grid>
                            </Grid>
                        </FormProvider>
                    </AccordionFund>
                </Grid>

                {/* Activity */}
                {isPermission &&
                    <Grid item xs={12}>
                        <AccordionFund
                            header={I18n.SetText("FundPlan.ActivityTopic")}
                        >
                            <FormProvider {...formActivity}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <SelectItem
                                            name="sActivityProject"
                                            label={I18n.SetText("FundPlan.ProjectName")}
                                            placeholder={`${I18n.SetText("FundPlan.Choose")}${I18n.SetText("FundPlan.Project")}`}
                                            required
                                            options={arrOptionProject}
                                            onChange={() => handleChangeProject()}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        <TextBoxItem
                                            name="sActivityName"
                                            label={I18n.SetText("FundPlan.ActivityName")}
                                            required
                                            maxLength={500}
                                            IsShowTextCont
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <CheckBoxItem
                                            name="isSubActivity"
                                            options={[{ value: "true", label: I18n.SetText("FundPlan.SubActivity") }]}
                                            onChange={(e) => handleChangeSubActivity(e)}
                                        />
                                    </Grid>
                                    {isSubActivity &&
                                        <Grid item xs={12}>
                                            <Wrapper>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <HeaderInput text={I18n.SetText("FundPlan.UnderActivity")} required />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Wrapper>
                                                            <Grid container spacing={2}>
                                                                {DefaultArrayEmpty(arrActivity).map((m, i) => {
                                                                    let nLevel = i + 1;
                                                                    let objPre = arrActivity[i - 1];
                                                                    let nParentID = null;
                                                                    if (objPre) {
                                                                        nParentID = formActivity.getValues(`sUnderActivity_${objPre.nID}`)
                                                                    }

                                                                    return (

                                                                        <Grid item xs={12} key={"input_activity_" + m.nID}>
                                                                            <SelectItem
                                                                                name={`sUnderActivity_${m.nID}`}
                                                                                label={I18n.SetText("FundPlan.Activity")}
                                                                                placeholder={`${I18n.SetText("FundPlan.Choose")}${I18n.SetText("FundPlan.Activity")}`}
                                                                                options={dataOptionActivity.filter(f => f.nParentID === nParentID && f.nProjectID === nProjectCurrent && f.nLevel === nLevel)}
                                                                                onChange={(e) => handleChangeActivity(e)}
                                                                            />
                                                                        </Grid>
                                                                    )
                                                                })}
                                                            </Grid>
                                                        </Wrapper>
                                                    </Grid>
                                                </Grid>
                                            </Wrapper>
                                        </Grid>
                                    }
                                    <Grid item xs={12}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={2}>
                                                <HeaderInput text={I18n.SetText("FundPlan.Duration")} />
                                            </Grid>
                                            <Grid item xs={12} md={10}>
                                                <FundActionPlanFormDuration
                                                    nYear={nYear}
                                                    formDuration={formDuration}
                                                    onAddDuration={onAddDuration}
                                                    onDeleteDuration={onDeleteDuration}
                                                    arrDuration={arrDuration}
                                                    nProjectCurrent={nProjectCurrent}
                                                    dataRowProject={dataRowProject}
                                                    nTrigger={nTriggerDuration}
                                                    nMaxMonth={nMaxMonth}
                                                    nMinMonth={nMinMonth}
                                                    setNMaxMonthDueDate={setNMaxMonthDueDate}
                                                    setNMinMonthDueDate={setNMinMonthDueDate}
                                                    nMinMonthDueDate={nMinMonthDueDate}
                                                    nMaxMonthDueDate={nMaxMonthDueDate}
                                                    isSubActivity={isSubActivity}
                                                    nMaxWeightActivity={nMaxWeight}
                                                    nParentID={nParentID}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <InputNumberItem
                                                    name="sBudget"
                                                    label={I18n.SetText("FundPlan.Budget")}
                                                    IsComma
                                                    IsAllowScientific
                                                    ShowDigits={2}
                                                    maxDigits={2}
                                                    endAdornment={I18n.SetText("FundPlan.Baht")}
                                                    max={nMaxBudget}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormProvider {...formAssign}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <DividerCustom txt={I18n.SetText("FundPlan.AssignActivity")} className="divider-chip" />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <AutoCompleteItem
                                                        id={'sAssignPerson'}
                                                        name={'sAssignPerson'}
                                                        sUrlAPI={`FundActionPlan/GetEmployeeFund`}
                                                        label={I18n.SetText("FundPlan.AssignName")}
                                                        placeholder={I18n.SetText("FundPlan.Search")}
                                                        required
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <DatePickerItem
                                                        name="sDueDate"
                                                        label={I18n.SetText("FundPlan.DueDate")}
                                                        IsDisablePortal={true}
                                                        required
                                                        minDate={moment(nMinMonthDueDate).isValid() ? moment(nMinMonthDueDate).startOf('month').year(nYear) : moment().startOf('year').year(nYear)}
                                                        maxDate={moment(nMaxMonthDueDate).isValid() ? moment(nMaxMonthDueDate).endOf('month').year(nYear) : moment().endOf('year').year(nYear)}
                                                        defaultCalendarMonth={moment().startOf('year').year(nYear)}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} display={"flex"} justifyContent={"right"}>
                                                    {nEditAssign ?
                                                        <BtnEdit
                                                            id="EditAssign"
                                                            txt={I18n.SetText("FundPlan.EditAssign")}
                                                            onClick={formAssign.handleSubmit(handleSubmitAssign, (err) => {
                                                                document.getElementById(Object.keys(err)[0])?.focus();
                                                            })}
                                                        />
                                                        :
                                                        <BtnAdd
                                                            id="AddAssign"
                                                            sColor="rgb(138, 8, 10)"
                                                            sColorHover="rgb(138, 8, 10)"
                                                            txt={I18n.SetText("FundPlan.AddAssign")}
                                                            onClick={formAssign.handleSubmit(handleSubmitAssign, (err) => {
                                                                document.getElementById(Object.keys(err)[0])?.focus();
                                                            })}
                                                        />
                                                    }
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TableEmployee
                                                        sColumnName={I18n.SetText("FundPlan.FullName")}
                                                        sColumnDate={I18n.SetText("FundPlan.DueDate")}
                                                        data={dataRowAssign}
                                                        onDelete={onDeleteAssign}
                                                        onEdit={handleEditAssign}
                                                        nEditID={nEditAssign}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </FormProvider>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CheckBoxItem
                                            name="isBoardMeeting"
                                            options={[{ value: "true", label: I18n.SetText("FundPlan.BoardMeeting") }]}
                                            onChange={(e) => handleChangeBoardMeeting(e)}
                                        />
                                    </Grid>
                                    {isBoardMeeting &&
                                        <Grid item xs={12}>
                                            <FormProvider {...formBoardMeetingTable}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <DividerCustom txt={I18n.SetText("FundPlan.BoardMeeting")} className="divider-chip" />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <TextBoxItem
                                                            name="sTopic"
                                                            label={I18n.SetText("FundPlan.Topic")}
                                                            required
                                                            maxLength={250}
                                                            IsShowTextCont
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <FundActionPlanFormBoardMeeting
                                                            arrOptionCommittee={arrOptionCommittee}
                                                            nYear={nYear}
                                                            form={formBoardMeeting}
                                                            onAddBoardMeeting={onAddBoardMeeting}
                                                            onDeleteBoardMeeting={onDeleteBoardMeeting}
                                                            arrBoardMeeting={arrBoardMeeting}
                                                            trigger={trigger}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} display={"flex"} justifyContent={"right"}>
                                                        {nEditCommittee ?
                                                            <BtnEdit
                                                                id="EditMeeting"
                                                                txt={I18n.SetText("FundPlan.EditMeeting")}
                                                                onClick={formBoardMeetingTable.handleSubmit(handleSubmitCommittee, (err) => {
                                                                    document.getElementById(Object.keys(err)[0])?.focus();
                                                                })}
                                                            />
                                                            :
                                                            <BtnAdd
                                                                id="AddMeeting"
                                                                sColor="rgb(138, 8, 10)"
                                                                sColorHover="rgb(138, 8, 10)"
                                                                txt={I18n.SetText("FundPlan.AddMeeting")}
                                                                onClick={formBoardMeetingTable.handleSubmit(handleSubmitCommittee, (err) => {
                                                                    document.getElementById(Object.keys(err)[0])?.focus();
                                                                })}
                                                            />
                                                        }
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <TableEmployee
                                                            sColumnName={I18n.SetText("FundPlan.GroupMeeting")}
                                                            sColumnDate={I18n.SetText("FundPlan.DurationMeeting")}
                                                            data={dataRowCommittee}
                                                            onDelete={onDeleteCommittee}
                                                            onEdit={handleEditCommittee}
                                                            nEditID={nEditCommittee}
                                                            IsHeadAction
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </FormProvider>
                                        </Grid>
                                    }
                                    <Grid item xs={12} display={"flex"} justifyContent={"right"}>
                                        {nEditActivity && nEditActivityProject ?
                                            <BtnEdit
                                                id="EditActivity"
                                                txt={I18n.SetText("FundPlan.EditActivity")}
                                                onClick={formActivity.handleSubmit(handleSubmitActivity, (err) => {
                                                    document.getElementById(Object.keys(err)[0])?.focus();
                                                })}
                                            />
                                            :
                                            <BtnAdd
                                                id="AddActivity"
                                                txt={I18n.SetText("FundPlan.AddActivity")}
                                                onClick={formActivity.handleSubmit(handleSubmitActivity, (err) => {
                                                    document.getElementById(Object.keys(err)[0])?.focus();
                                                })}
                                            />
                                        }
                                    </Grid>
                                </Grid>
                            </FormProvider>
                        </AccordionFund>
                    </Grid>
                }

                {/* table Activity */}
                <Grid item xs={12}>
                    <TableActivity
                        data={dataRowActivity}
                        onDelete={onDeleteActivity}
                        onEdit={handleEditActivity}
                        nEditID={nEditActivity}
                        nEditParentID={nEditActivityProject}
                        isPermission={isPermission}
                    />
                </Grid>

                {/* upload file */}
                <Grid item xs={12} sx={{ padding: "30px 16px !important" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <UploadFileItem
                                id={`arrFileMOU`}
                                name={`arrFileMOU`}
                                label={I18n.SetText("FundPlan.FileMOU")}
                                IsDrag={false}
                                required={false}
                                arrFile={arrFileMOU}
                                setarrFile={setArrFileMOU}
                                IsFolder={false}
                                IsMultiple
                                Extension={[...Extension.FileTicket, ...Extension.Word]}
                                nLimitFile={30}
                                sLimitFile={"MB"}
                                onClearFile={handleClearAttachFileMOU}
                                modeDisplay={"list"}
                                sFolderTemp={"FundWork"}
                                sPositionText={"right"}
                                disabled={!isPermission}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <UploadFileItem
                                id={`arrFilePlan`}
                                name={`arrFilePlan`}
                                label={I18n.SetText("FundPlan.FilePlan")}
                                IsDrag={false}
                                required={false}
                                arrFile={arrFilePlan}
                                setarrFile={setArrFilePlan}
                                IsFolder={false}
                                IsMultiple
                                Extension={[...Extension.FileTicket, ...Extension.Word]}
                                nLimitFile={30}
                                sLimitFile={"MB"}
                                onClearFile={handleClearAttachFilePlan}
                                modeDisplay={"list"}
                                sFolderTemp={"FundWork"}
                                sPositionText={"right"}
                                disabled={!isPermission}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                {/* button action */}
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <BtnBack
                                id="back"
                                onClick={onBack}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            {isPermission &&
                                <Grid container display={"flex"} justifyContent={"flex-end"} spacing={1} >
                                    {!isSubmitted &&
                                        <Grid item>
                                            <BtnDraft
                                                id="draft"
                                                onClick={handleDraft}
                                            />
                                        </Grid>
                                    }
                                    <Grid item>
                                        <BtnSave
                                            id="save"
                                            onClick={form.handleSubmit(handleSubmitPlan, (err) => {
                                                document.getElementById(Object.keys(err)[0])?.focus();
                                            })}
                                        />
                                    </Grid>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </FormProvider>
        // </FuncActionPlanContextProvider>
    )
}